// Event location enum matching the cloud script
export enum EventLocation {
    PUBLIC = 'public',
    PRIVATE = 'private', 
    PENDING = 'pending',
    INVITE = 'invite',
    ARCHIVED = 'archive',
    DRAFT = 'draft'
}

// Event transition model matching the cloud script structure
export type EventTransitionModel = {
    eventId: string;
    source: {
        location: EventLocation;
    };
    destination: {
        location: EventLocation;
    };
};

// Helper type for the allowed event location values
export type EventLocationKey = keyof typeof EventLocation;
export type EventLocationValue = `${EventLocation}`;

// File formats for exporting an event's scores
export type ScoreExportFormat = 'csv' | 'json';

// Who is invited to an Invite event: events/inviteAccess/{eventId}/{playerId} = true
export type InviteRoster = { [playerId: string]: boolean };
